module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.booking_number ||
        _vm.Filter.container_number ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.search_txt ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ||
        _vm.Filter.StatusVerbose ||
        _vm.Filter.hasDateMismatch ||
        _vm.Filter.daysFilter ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.booking_number ||
    _vm.Filter.container_number ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.search_txt ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ||
    _vm.Filter.StatusVerbose ||
    _vm.Filter.hasDateMismatch ||
    _vm.Filter.daysFilter ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getTimeLineList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getTimeLineList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.pageSize,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  })], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Booking NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Booking NO Filter",
      "id": "booking_number",
      "name": "booking_number",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.booking_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "booking_number", $$v)
      },
      expression: "Filter.booking_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container No Filter",
      "id": "container_number",
      "name": "container_number",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.container_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "container_number", $$v)
      },
      expression: "Filter.container_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Days")]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "options": _vm.dayOptions,
      "placeholder": "Select Days"
    },
    on: {
      "change": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.daysFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "daysFilter", $$v)
      },
      expression: "Filter.daysFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "search_txt",
      "name": "search_txt",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.search_txt),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "search_txt", $$v)
      },
      expression: "Filter.search_txt"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status Verbose")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusVerboseList,
      "option-value": "StatusVerboseVal",
      "option-text": "StatusVerboseTxt",
      "placeholder": "Select Status Verbose"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.StatusVerbose),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "StatusVerbose", $$v)
      },
      expression: "Filter.StatusVerbose"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Mismatch Actual/Initial")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.hasDateMismatchList,
      "option-value": "hasDateMismatchVal",
      "option-text": "hasDateMismatchTxt",
      "placeholder": "Select Mismatch Actual/Initial"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.hasDateMismatch),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "hasDateMismatch", $$v)
      },
      expression: "Filter.hasDateMismatch"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getTimeLineList,
      "fields": _vm.TimeLineFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.pageSize,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.pageSize) + "\n                ")])]
      }
    }, {
      key: "RaisedFrom",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Branch:")]), _vm._v(" " + _vm._s((row0.item.RaisedFrom)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Empty Pickup Loc:")]), _vm._v(" " + _vm._s((row0.item.EmptyPickupLoc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Origin Loc:")]), _vm._v(" " + _vm._s((row0.item.OriginLoc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s((row0.item.PolLoc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s((row0.item.PodLoc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("DLV Loc:")]), _vm._v(" " + _vm._s((row0.item.DlvLoc)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Empty Return Loc:")]), _vm._v(" " + _vm._s((row0.item.EmptyReturnLoc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Tsp1 Loc:")]), _vm._v(" " + _vm._s((row0.item.Tsp1Loc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Tsp2 Loc:")]), _vm._v(" " + _vm._s((row0.item.Tsp2Loc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Tsp3 Loc:")]), _vm._v(" " + _vm._s((row0.item.Tsp3Loc)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Tsp4 Loc:")]), _vm._v(" " + _vm._s((row0.item.Tsp4Loc)))])]
      }
    }, {
      key: "StatusVerbose",
      fn: function(row0) {
        return [_c('span', [_c('strong', [_vm._v("Status Verbose:")]), _vm._v(" " + _vm._s((row0.item.StatusVerbose)))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Message:")]), _vm._v(" " + _vm._s((row0.item.EventMessage)))])]
      }
    }, {
      key: "BookingNumber",
      fn: function(row0) {
        return [_c('strong', {
          style: ((row0.item.subscription_id) ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              (row0.item.subscription_id) ? _vm.goToSubscriptionPage(row0.item): ''
            }
          }
        }, [_vm._v("Booking No: " + _vm._s((row0.item.BookingNumber)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s((row0.item.JobNo)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s((row0.item.JobDate)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s((row0.item.RaisedBy)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s((row0.item.ClientName)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("BrfNo:")]), _vm._v(" " + _vm._s((row0.item.BrfNo)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("IncoTerm:")]), _vm._v(" " + _vm._s((row0.item.IncoTerm)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Bl Type:")]), _vm._v(" " + _vm._s((row0.item.BlType)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("MblNo:")]), _vm._v(" " + _vm._s((row0.item.MblNo)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Mbl Release:")]), _vm._v(" " + _vm._s((row0.item.MblReleaseDate)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Mbl Date:")]), _vm._v(" " + _vm._s((row0.item.MblDate)))]), _c('br')]
      }
    }, {
      key: "container_number",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_vm._v("Container No: " + _vm._s((row0.item.container_number)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_vm._v("Vessel Voyage 1: " + _vm._s((row0.item.Vessel1 + ' / ' + row0.item.Voyage1)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_vm._v("Vessel Voyage 2: " + _vm._s((row0.item.Vessel2 + ' / ' + row0.item.Voyage2)))])]
      }
    }, {
      key: "SobPlanInitial",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.SobPlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.PolPlanActual)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Plan:")]), _vm._v(" " + _vm._s((row0.item.SobPlanActual)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.SobPlanDetected)))])]
      }
    }, {
      key: "Tsp4DepartureLast",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("SI:")]), _vm._v(" " + _vm._s((row0.item.SiCB + "/" + row0.item.SiMain)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("VGM:")]), _vm._v(" " + _vm._s((row0.item.VgmCb + "/" +
          row0.item.VgmMain)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("TR:")]), _vm._v(" " + _vm._s((row0.item.TrCb + "/" + row0.item.TrMain)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Hand:")]), _vm._v(" " + _vm._s((row0.item.HandoverCB + "/" +
          row0.item.HandoverMain)))])]
      }
    }, {
      key: "Tsp4PlanActual",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.EmptyPickupPlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Last:")]), _vm._v(" " + _vm._s((row0.item.EmptyPickupPlanLast)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.EmptyPickupPlanActual)))])]
      }
    }, {
      key: "Tsp4PlanLast",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.OriginPlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Last:")]), _vm._v(" " + _vm._s((row0.item.OriginPlanLast)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.OriginPlanActual)))])]
      }
    }, {
      key: "Tsp4PlanInitial",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.PolPlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.PolPlanLast)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.PolPlanActual)))])]
      }
    }, {
      key: "Tsp4Loc",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.PodPlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.PodPlanActual)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Plan:")]), _vm._v(" " + _vm._s((row0.item.PodDepartureInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.PodDepartureActual)))])]
      }
    }, {
      key: "Tsp3DepartureLast",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp1PlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp1PlanActual)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp1DepartureInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp1DepartureActual)))])]
      }
    }, {
      key: "Tsp3PlanActual",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp2PlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp2PlanActual)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp2DepartureInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp2DepartureActual)))])]
      }
    }, {
      key: "Tsp3PlanInitial",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp3PlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp3PlanActual)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp3DepartureInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp3DepartureActual)))])]
      }
    }, {
      key: "Tsp1DepartureLast",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp4PlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp4PlanActual)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Plan:")]), _vm._v(" " + _vm._s((row0.item.Tsp4DepartureInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.Tsp4DepartureActual)))])]
      }
    }, {
      key: "Tsp1DepartureInitial",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Plan:")]), _vm._v(" " + _vm._s((row0.item.EmptyReturnPlanInitial)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Arrival Actual:")]), _vm._v(" " + _vm._s((row0.item.EmptyReturnPlanLast)))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('strong', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s((row0.item.EmptyReturnPlanActual)))])]
      }
    }, {
      key: "Tsp1PlanActual",
      fn: function(row0) {
        return undefined
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.pageSize,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b2551d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/tracking/milestoneTrackTable.vue
// module id = 2811
// module chunks = 0